<template>
  <div class="homepartner col-md-12 m-0 p-0">
    <div class="comp-title">
      <div class="left">
        <h1 class="text-uppercase color-text-bold">
          <img src="../../../../static/img/comp-title.png"/>
          Đối tác
        </h1>
      </div>
    </div>
    <div style="clear: both"></div>

    <div class="partner row">
      <div class="item">
        <img src="../../../../static/img/youtube.png" />
      </div>
      <div class="item">
        <img src="../../../../static/img/zing.png" />
      </div>
      <div class="item">
        <img src="../../../../static/img/nhaccuatui.png" />
      </div>
      <div class="item">
        <img src="../../../../static/img/vinaphone.png" />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Partner",
    components: {
    },
    data () {
      return {

      }
    },
    mounted () {

    }
  }
</script>

<style scoped>
  .partner .item{
    border: 1px solid #ccc;
    margin-right: 2rem;
    width: calc(100% / 4.8);
    line-height: 66px;
    border-radius: 5px;
  }
  .partner img{
    width: 120px;
    height: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/web/Partner.vue